export const appCdnURL = "https://static.%%static_replace%%/"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico","id":"favicon"}],"style":[],"script":[{"type":"text/javascript","innerHTML":"\n          (function() {\n            const url = new URL(location.href);\n            const matches = url.pathname.match(/(\\/w{2}-\\w{2}\\/)?(futures)/)\n            const isFuturePage = (matches && matches[2]) === 'futures';\n            const queryTheme = url.searchParams.get('theme')\n            const futureStoreTheme = isFuturePage ? localStorage.getItem('futures-ttx-theme') : ''\n            const theme = queryTheme || futureStoreTheme;\n            if (theme) {\n              document.documentElement.setAttribute('theme', theme);\n            }\n          })();\n        "}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false